import React from 'react';
import { FaArrowRight } from "react-icons/fa";

const Button = ({ text, className = "", onClick, size = "md", ...props }) => {
    const isSmall = size === "sm";
    return (
        <button
            {...props}
            onClick={onClick}
            className={`group relative flex items-center ${isSmall ? 'gap-3 p-1 pr-6' : 'gap-5 p-2 pr-10'} bg-[#f04e23] text-white rounded-full w-fit overflow-hidden transition-all duration-500 hover:scale-105 hover:shadow-[0_20px_40px_-15px_rgba(240,78,35,0.4)] ${className}`}
        >
            {/* White fill background */}
            <div className="absolute inset-0 bg-white translate-x-[-101%] group-hover:translate-x-0 transition-transform duration-500 ease-out" />

            {/* Icon Circle */}
            <div className={`relative z-10 ${isSmall ? 'w-8 h-8' : 'w-12 h-12'} rounded-full border border-white flex items-center justify-center bg-transparent transition-all duration-500 group-hover:bg-[#f04e23] group-hover:border-[#f04e23]`}>
                <FaArrowRight className={`${isSmall ? 'text-[10px]' : 'text-sm'} transition-all duration-500 group-hover:rotate-[-45deg] group-hover:text-white`} />
            </div>

            {/* Text Swap Animation */}
            <div className={`relative z-10 overflow-hidden ${isSmall ? 'h-3' : 'h-4'} flex flex-col justify-start`}>
                <span className={`block font-black uppercase tracking-[0.2em] ${isSmall ? 'text-[9px]' : 'text-[11px]'} transition-transform duration-500 group-hover:-translate-y-full`}>
                    {text}
                </span>
                <span className={`block absolute top-full font-black uppercase tracking-[0.2em] ${isSmall ? 'text-[9px]' : 'text-[11px]'} text-black transition-transform duration-500 group-hover:-translate-y-full`}>
                    {text}
                </span>
            </div>
        </button>
    );
};

export default Button;
